import { render, staticRenderFns } from "./Scene7.vue?vue&type=template&id=1f2beffc&"
import script from "./Scene7.vue?vue&type=script&lang=js&"
export * from "./Scene7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports